module.exports = __webpack_public_path__ + "img/gb-nir.svg";